import { get, isEmpty } from "lodash";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "shared/components/Spin";
import { StoreContext } from "shared/store";
import { SCREENS, USER_TYPES } from "utils/constants";

const Redirect = () => {
  const navigate = useNavigate();
  const { accessToken, user } = useContext(StoreContext);
  useEffect(() => {
    if (isEmpty(user) && !accessToken)
      return navigate(SCREENS.AUTH.LOGOUT.path, {
        replace: true,
      });

    if (get(user, "meta.type") === USER_TYPES.EXTERNAL_ADVISOR.type) {
      return navigate(SCREENS.AUTH.NOT_AUTHORIZED.path, {
        replace: true,
      });
    }
    navigate(SCREENS.AUTH.SIGN_IN.path, {
      replace: true,
    });
  }, [accessToken]);

  return <Loading />;
};

export default Redirect;
